import { useAxiosPost } from "../axios";

// given a fullname, return initials, consider all cases and undefined, uppercase the initials too
export const getInitials = (fullname: string | undefined) => {
  if (!fullname) return "A"; // Anonymous User
  try {
    const names = fullname.trim().split(" ");
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    return names[0].charAt(0).toUpperCase() + names[names.length - 1].charAt(0).toUpperCase();
  } catch (error) {
    return "A";
  }
};

export const getMyAccountManager = async (userId: string) => {
  try {
    const response = await useAxiosPost("/users/get-my-account-manager", { userId });
    if (!response?.data?.success) throw new Error("Failed to get account manager");
    return response.data.payload;
  } catch (error) {
    return null;
  }
};
